import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import Page403 from '@page/Common/403/403';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { usePermission } from '@contexts/Auth/UsePermission';
import List from '@page/StatisticsByMonthV2/components/List';

const StatisticsByMonthCnhp = () => {
  const { cnhpComparison } = usePermission();

  if (!cnhpComparison.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath="/dashboard"
          routeSegments={[{ name: 'Đối soát tiêu thụ thực tế CNHP' }]}
        />
      </div>
      <List cnhpComparison />
    </ContainerBody>
  );
};

export default compose(withPaginate)(StatisticsByMonthCnhp);
